import { ObjectOps } from '../lift';
/**
 * Removes a key/value from this heterogeneous object.
 * To remove a (nullable) key from an object while preserving its type, use "update()" instead.
 * To remove a key from a homogeneous key/value object, use "dissoc" instead.
 */
export function remove(keyToRemove) {
    var obj = this.value();
    var keyToRemoveStr = keyToRemove.toString();
    var result = {};
    Object.keys(obj).forEach(function (key) { if (key !== keyToRemoveStr)
        result[key] = obj[key]; });
    return new ObjectOps(result);
}
ObjectOps.prototype.remove = remove;
